import type { AccountBranding } from '@/api/accountConfig';
import type { UserProfile } from '@/api/user';
import { useAccountConfigQuery } from './useAccountConfigQuery';

interface AccountBrandingState {
  branding: AccountBranding | undefined;
  isFetched: boolean;
}

/**
 * The account's brand colour and logo, from `GET /accounts/current/config`. Takes the user
 * explicitly because `AuthContext` itself applies the colour.
 */
export const useAccountBranding = (user: UserProfile | null | undefined, enabled = true): AccountBrandingState => {
  const { data, isFetched } = useAccountConfigQuery(user, enabled);
  return { branding: data?.branding, isFetched };
};
